import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBed, FaCalendarCheck, FaSignOutAlt } from "react-icons/fa";
import { CiCalculator2 } from "react-icons/ci";
import { FaUsers } from "react-icons/fa6";
import { MdArticle } from "react-icons/md";
import "./sidebarAdmin.css";

const NavbarAdmin = () => {
  const [articleMenuOpen, setArticleMenuOpen] = useState(false);

  const toggleArticleMenu = () => {
    setArticleMenuOpen((prev) => !prev);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/admins/logout`, {
        method: "POST",
        credentials: "include",
      });

      localStorage.removeItem("token");
      window.location.href = "/Connexion";
    } catch (error) {
      console.error("Erreur lors de la déconnexion", error);
    }
  };

  return (
    <nav className="sidebar">
      <h1 className="sidebar-title">Hotel Syphax</h1>

      <div className="sidebar-links">
        <div className="sidebar-main-links">
          <NavLink
            to="/GestionDesChambres"
            className={({ isActive }) =>
              isActive ? "active sidebar-link" : "sidebar-link"
            }
          >
            <FaBed /> Gestion des chambres
          </NavLink>

          <NavLink
            to="/GestionDesReservations"
            className={({ isActive }) =>
              isActive ? "active sidebar-link" : "sidebar-link"
            }
          >
            <FaCalendarCheck /> Gestion des réservations
          </NavLink>

          <NavLink
            to="/NosClients"
            className={({ isActive }) =>
              isActive ? "active sidebar-link" : "sidebar-link"
            }
          >
            <FaUsers /> Nos clients
          </NavLink>

          <NavLink
            to="/Calculator"
            className={({ isActive }) =>
              isActive ? "active sidebar-link" : "sidebar-link"
            }
          >
            <CiCalculator2 style={{ fontSize: "22px" }} /> Calculatrice
          </NavLink>
          <div className="sidebar-link-group">
          <div
  className={`sidebar-link ${articleMenuOpen ? "active" : ""}`}
  onClick={toggleArticleMenu}
  style={{ cursor: "pointer" }}
>
  <MdArticle /> Gestion des articles
</div>

            {articleMenuOpen && (
              <div className="sidebar-sublinks">
                <NavLink
                  to="/RedactionArticle"
                  className={({ isActive }) =>
                    isActive ? "active sidebar-sublink" : "sidebar-sublink"
                  }
                >
                  ➤ Rédiger un article
                </NavLink>
                <NavLink
                  to="/EditionArticle"
                  className={({ isActive }) =>
                    isActive ? "active sidebar-sublink" : "sidebar-sublink"
                  }
                >
                  ➤ Éditer un article
                </NavLink>
              </div>
            )}
          </div>
        </div>

        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt /> Déconnexion
        </button>
      </div>
    </nav>
  );
};

export default NavbarAdmin;
